import { Outlet } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { ErrorBoundary } from "@/error/ErrorBoundary";
import { LoadingBoundary } from "@/ui/LoadingBoundary";
import { PreloadCompatibleRouteProvider } from "./PreloadCompatibleRouteProvider";
import {
    ResizableHandle,
    ResizablePanel,
    ResizablePanelGroup
} from "@/components/ui/resizable";
import { PageFrame } from "./PageFrame";

export const Template = () => {
    return (
        <SidebarProvider>
            <div className="flex md-not-print:h-screen w-full">
                <ResizablePanelGroup
                    direction="horizontal"
                    autoSaveId="AppSidebar"
                    className="contents md-not-print:flex"
                    style={{ display: undefined }} // don't let resizable set display property
                >
                    <ResizablePanel
                        className="relative min-w-[200px] hidden md-not-print:block"
                        minSize={10}
                        defaultSize={16}
                        maxSize={50}
                    >
                        <AppSidebar />
                    </ResizablePanel>
                    <ResizableHandle />
                    <ResizablePanel className="contents md-not-print:block md-not-print:relative">
                        <SidebarInset className="@container">
                            <ErrorBoundary
                                fallbackWrapper={children => (
                                    // ensure mobile open nav button is visible, even if an error has triggered
                                    <PageFrame breadcrumbReplacement={<></>}>
                                        {children}
                                    </PageFrame>
                                )}
                            >
                                {/* page content loading boundary */}
                                <LoadingBoundary absolute={true}>
                                    <PreloadCompatibleRouteProvider>
                                        <Outlet />
                                    </PreloadCompatibleRouteProvider>
                                </LoadingBoundary>
                            </ErrorBoundary>
                        </SidebarInset>
                    </ResizablePanel>
                </ResizablePanelGroup>
            </div>
        </SidebarProvider>
    );
};
